import { render, staticRenderFns } from "./BasicOptionTable.vue?vue&type=template&id=72168905&scoped=true"
import script from "./BasicOptionTable.vue?vue&type=script&lang=js"
export * from "./BasicOptionTable.vue?vue&type=script&lang=js"
import style0 from "./BasicOptionTable.vue?vue&type=style&index=0&id=72168905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72168905",
  null
  
)

export default component.exports